export default __webpack_public_path__ + "static/media/review-6.26b19b69.png";